import { LogsInitConfiguration } from "@datadog/browser-logs";

export const emptyDatadogLogsInitConfig: Omit<LogsInitConfiguration, 'clientToken'> = {
    site: 'datadoghq.com',
    service: 'dat-iq',
    version: '1.0.0',
    forwardErrorsToLogs: false, // already handled by RUM
};
